import AutoNumeric from 'autonumeric';

function configMascaras() {
	// máscaras
	$('.mask-valor').wrap('<div class="mask-valor-wrap">');
	$('.mask-percentual').wrap('<div class="mask-percentual-wrap">');

	var anOptions = {
	    decimalCharacter: ",",
	    digitGroupSeparator: ".",
	    decimalPlacesRawValue: 2
	}

	if($('.mask-decimal').length > 0) {
		new AutoNumeric.multiple('.mask-decimal', anOptions);	
	}
	if($('.mask-percentual').length > 0) {
		new AutoNumeric('.mask-percentual', anOptions);
	}
	if($('.mask-valor').length > 0) {
		new AutoNumeric.multiple('.mask-valor', anOptions);
	}

	var maskBehavior = function (val) {
		var nums = val.replace(/\D/g, '');

		//console.log(nums);

		if(nums.length === 11) {
			if(val.startsWith('+')) {
				return '+0 000-000-00009';
			} else if(nums.startsWith('0800')) {
				return '0000-000-0000';
			} else {
				return '(00) 0 0000-0000';
			}
		} else if (nums.length > 11) {
			if(val.startsWith('+')) {
				return '+0 (000) 000-000-0999';
			} else {
				return '(00) 0 0000-0000';
			}
		} else if (nums.length === 10) {
			if(val.startsWith('+')) {
				return '+0 000-000-0009';
			} else {
				return '(00) 0000-00009';
			}
		} else if (nums.length === 2) {
			if(val.startsWith('+')) {
				return '+0 000-000-0000';
			} else if(nums.startsWith('08')) {
				return '0000-000-0000';
			} else {
				return '(00) 0000-0000';
			}
		} else {
			return 'z00) 0000-00009';
		}
	},
	options = {
		onKeyPress: function(val, e, field, options) {
			field.mask(maskBehavior.apply({}, arguments), options);
		},
		translation: {
			'z': {pattern: /\(|\+/, optional: true},
		}
	};
	$('.mask-phone').mask(maskBehavior, options);

	$('.mask-cpf').mask('000.000.000-00');
	$('.mask-cnpj').mask('00.000.000/0000-00');
	$('.mask-cep').mask('00000-000');
	$('.mask-hora').mask('00:00:00');
	$('.mask-hora-min').mask('00:00');
	$('.mask-data').mask('00/00/0000');
	$('.mask-data-mes').mask('00/00');
}

export default configMascaras
